<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(HeaderGlobalHeading="Multi Tracking" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Multi Tracking List
                    .header-cta
                        router-link.btn-primary(to="/multi-tracking/create")                                
                            //- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user-plus"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
                            //- span(style="padding-left: 8px;") Add New Multi Tracking
                            span Add New Multi Tracking
            .box__body
                .form.p-4
                    .flex.flex-wrap.items-center.justify-between
                        .field.relative.field--search.mb-3(
                            class="lg:mb-0"
                        )
                            input.field-style(id="field" type="text" v-model="keyword" placeholder="Search multi tracking here..." @keyup="searchKeyword")
                            .absolute.inset-y-0.right-0.flex.items-center.px-2
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>

                        .flex.items-center.w-full(
                            class="lg:w-48"
                        )
                            span.block.mr-2 Show
                            .field.mr-2.relative.w-full
                                select.w-full.field-style.py-2.px-2.pr-8.rounded.leading-tight#filter-record-size(@change="sizeChange($event)" v-model="items_per_page")
                                    option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                            span entries

                        //- div.flex.items-center
                            .field.field--checkbox.mr-2
                                .wrapper-checkbox
                                    input(type="checkbox" v-model="monitoringOnly")
                                    .ui-checkbox.flex.items-center
                                        .checkbox.flex.items-center.justify-center
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                        strong Monitoring Only


                div.flex.items-center.justify-between.bg-gray-100.p-4(v-if='monitoringOnly')
                    span.text-sm Monitoring started at 9 maret 2020 15:00 WIB
                    button.btn-primary-o Stop All
                
                .table-static.w-full.table-multi-track
                    table
                        thead
                            tr.m-hide
                                th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                        tbody
                            tr(v-if="load_data_status_multi_tracking_list === 'loading'")
                                td.text-center(:colspan="tableThead.length")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")
                                    
                            template(v-else-if="multi_tracking_list.data && multi_tracking_list.data.length > 0")
                                tr(v-for="(data,index) in multi_tracking_list.data" :key="data.id")
                                    td
                                        router-link.link-text(:to="'/multi-tracking/'+data.id+'/detail'") {{ data.group_name ? data.group_name : '-' }}
                                        //- button.flex.items-center(@click="detailTarget(data)")
                                            figure.w-12.h-12.mr-4
                                                img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="data.photo ? data.photo : getDefaultImage" @error="getDefaultImage")

                                        //- | {{ data.group_name ? data.group_name : '-' }}
                                    //- td.w-5.text-center
                                        label(:class="[`inline-block bg-${data.label}-500 w-4 h-4 rounded-full`]")

                                    
                                    //- td {{ data.target && data.target.length > 0 ? data.target.length : '-' }}
                                    td(v-if="data.target && data.target.length > 0")
                                        .flex.items-center.list-target
                                            .list-target__avatar(v-for="target in data.target.slice(0, 9)")
                                                .hidden {{ target.target_name }} : {{ target.msisdn && target.msisdn.length > 0 ? target.msisdn.join(', ') : '-' }}
                                                figure.w-12.h-12.overflow-hidden.rounded-full.bg-white.border-4(v-tooltip="target.target_name")
                                                    img.w-full.h-full.object-cover(
                                                        :src="target.photo ? target.photo : getDefaultImage"
                                                        @error="getDefaultImage"
                                                    )
                                            .list-target__more.w-12.h-12.overflow-hidden.rounded-full.bg-white.border-4.flex.items-center.justify-center.bg-white(v-if="data.target.length > 10")
                                                span.text-sm +{{ data.target.length - 10 }}
                                    td(v-else) -


                                    //- td 
                                        ul
                                            li(v-for="clue in countClues(data.clues)")
                                                strong {{ clue.count }} 
                                                span {{ clue.name }}
                                    td 
                                        template(v-for="item in data.cases")
                                            .no-wrap-text {{data.cases.length > 1? '-' : ''}} {{ item.operation_name }}
                                        //- small.no-wrap-text {{ toString(data.cases) }}
                                        //- small.no-wrap-text {{ data.case.operation_name }}
                                    td 
                                        p {{ data.description ? (data.description.length > 50 ? data.description.substring(0, 50)+'...' : data.description) : '-' }}
                                    td 
                                        small.m-hide {{ data.updated_at }}
                                    td.mobile-action-multi(:class="data.status.toLowerCase()==='stop' ? 'action' : 'text-right'")
                                        div.inline-flex.items-center
                                            //- button.btn-small.btn-default.ml-2(v-tooltip="'Meeting Point'" @click="getMeetingPoint(data)")
                                            //- router-link.btn-small.btn-default.ml-2(:to="'/multi-tracking/'+data.id+'/detail'" v-tooltip="'Detail'")
                                                div.text-gray-500
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                            button.btn-small.btn-monitoring
                                                template(v-if="data.status.toLowerCase()==='stop'")
                                            button.btn-small.btn-monitoring.ml-2
                                                .block(v-if="data.status.toLowerCase()==='stop'")
                                                    div(v-on:click="monitoringModal(data)" v-tooltip="'Start Monitoring'")
                                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16 29.3334C23.3638 29.3334 29.3334 23.3638 29.3334 16C29.3334 8.63622 23.3638 2.66669 16 2.66669C8.63622 2.66669 2.66669 8.63622 2.66669 16C2.66669 23.3638 8.63622 29.3334 16 29.3334Z" stroke="#8997A9" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M12 9.83167C12 9.0405 12.8752 8.56266 13.5408 8.99049L23.1359 15.1588C23.7483 15.5525 23.7483 16.4475 23.1359 16.8412L13.5408 23.0095C12.8752 23.4373 12 22.9595 12 22.1683V9.83167Z" fill="#8997A9"/>
                                                        </svg>
                                                template(v-else)
                                                    .on-monitoring(v-on:click="monitoringAction(0,data)" v-tooltip="'Stop Monitoring'")
                                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16 29.3334C23.3638 29.3334 29.3333 23.3638 29.3333 16C29.3333 8.63622 23.3638 2.66669 16 2.66669C8.63619 2.66669 2.66666 8.63622 2.66666 16C2.66666 23.3638 8.63619 29.3334 16 29.3334Z" stroke="#D71F1F" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <rect x="10.6667" y="10.6667" width="10.6667" height="10.6667" rx="1" fill="#D71F1F"/>
                                                        </svg>

                                            router-link.btn-icon.btn-icon-40.m-hide(:to="'/multi-tracking/'+data.id+'/edit'" v-tooltip="'Edit'" v-if="data.status.toLowerCase()==='stop'")
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
                                            //- button.btn-small.btn-default.ml-2(v-tooltip="'Meeting Point'" @click="getMeetingPoint(data)")

                                            button.btn-icon.btn-icon-40.m-hide(v-tooltip="'Delete'" @click="deleteData(data.id, data.group_name)" v-if="data.status.toLowerCase()==='stop'")
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                            tr(v-else)
                                td.text-center(:colspan="tableThead.length") No Data Available
                    .mt-5
                    vue-ads-pagination(
                        :total-items="total_data"
                        :items-per-page="items_per_page"
                        :page="page"
                        :max-visible-pages="5"
                    )
                        template(slot="buttons" slot-scope="props")
                            vue-ads-page-button(
                                v-for="(button, key) in props.buttons"
                                :key="key"
                                v-bind="button"
                                :class="{'bg-yellow-dark': button.active}"
                                @page-change="page = button.page"
                                @range-change="start = button.start; end = button.end"
                            )

    //- pop up tracker

    section(v-if="monitoringData").section-popup.section-popup--show.fixed.w-full-h.full.bg-gray-100.inset-0.flex.items-start.justify-center
        .section-popup__container
            .box
                .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            div.flex.items-center
                                span.text-light.name-index {{ monitoringData.group_name }}
                        .header-cta
                            button.btn-icon.btn-icon-40(v-on:click="monitoringModal()")
                                .icon-btn
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                .box__body.p-4
                    .block
                        strong.block.text-xs.uppercase.mb-4 Select Target
                        div.flex.items-center.flex-wrap
                            .choosen-target(style="width: 100%")
                                template(v-if="monitoringData.target.length > 0")
                                    .choosen-target__list.rounded.mb-4(
                                        v-for="(target, index) in monitoringData.target"
                                        :keys="index"
                                    )
                                        .flex.items-center.justify-between.border-b.border-b.p-4
                                            .flex.items-center
                                                figure.w-6.h-6.mr-4
                                                    img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="target.photo ? target.photo : getDefaultImage"
                                            @error="getDefaultImage")
                                                span.text-light.name-index {{ target.target_name }}
                                        .clues.flex.items-center.p-4
                                            .field(class="w-1/3" v-for="(target_msisdn, index) in target.msisdn" :key="index")
                                                .wrapper-checkbox
                                                    input(type="checkbox" v-model="monitoringTarget" :key="target_msisdn" :value="'id:'+target.id + ',msisdn:' + target_msisdn") 
                                                    //- @change="checkTargetMsisdn($event, target.id, target_msisdn)")
                                                    //- input(type="checkbox" v-model="monitoringTarget" :value="targetValue()" )
                                                    //- @change="checkTargetMsisdn($event, target.id, target_msisdn)")
                                                    .ui-checkbox.flex.items-center
                                                        .checkbox.flex.items-center.justify-center
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                        strong {{ target_msisdn }}
                                
                            //- .field.field--checkbox.mb-4(class="w-1/3" v-for="data in monitoringData.clues" v-if="data.name === 'msisdn'")
                                .wrapper-checkbox
                                    input(type="checkbox" v-model="monitoringTarget" :value="data.value")
                                    .ui-checkbox.flex.items-center
                                        .checkbox.flex.items-center.justify-center
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                        strong {{data.value}}

                    .block.border-b.mb-4.pb-4
                        strong.block.text-xs.uppercase.mb-4 Frequency Monitoring
                        div.flex.items-center.flex-wrap
                            .field.field--radio.mb-4(class="w-1/3" v-for="data in freqOpt")
                                .wrapper-radio
                                    input(type="radio" name="radio" v-model="monitoringFreq" :value="data.value")
                                    .ui-radio.flex.items-center
                                        .radio.flex.items-center.justify-center
                                        strong {{data.name}}

                    .flex.items-center.justify-between
                        span.text-sm
                            //- Start date 10 maret 2020
                        button.btn-primary.btn-large(@click="monitoringAction(1)") Start Monitoring
                        

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
// import { encrypt } from '@/util/crypto';

export default {
    name: 'PageMultiTrackingIndex',
    components: {
        HeaderGlobal,
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Multi Tracking',
                    url: '/multi-tracking',
                },
            ],
            monitoringData: null,
            monitoringTarget: [],
            monitoringFreq: 'every30minutes',
            freqOpt: this.$store.getters.getFreqMonitoring,
            monitoringOnly: false,
            popupShowMonitoring: false,
            meetingPointData: null,
            popupMeetingPoint: false,
            tableThead: [
                {
                    name: 'Group Name',
                },{
                    name: 'Target',
                },{
                    name: 'Operation Name',
                },{
                    name: 'Description',
                },{
                    name: 'Last Updated',
                },{
                    name: '',
                    action: true,
                },
            ],
           
            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            keyword: '',
            timeout: null,
            defaultImage: require('../../assets/no-image-profile.jpg'),
        }
    },
    computed: {
        ...mapState([
            'load_data_status_multi_tracking_list',
            'multi_tracking_list',
            'load_data_status_meeting_point_list',
            'meeting_point_list',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageMultiTrackingIndex') {
                this.getData();
            }

            if (newData === 'PageMultiTrackingIndex') {
                if (oldData !== 'PageMultiTrackingIndex') {
                    this.items_per_page = 10;
                    this.page = 0;
                    this.keyword = '';
                    this.$store.commit('setMultiTrackingList', {});
                }

                this.getData();
            }
        },
        multi_tracking_list(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            } else {
                this.total_data = 0;
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        keyword() {},
    },
    methods: {
        checkMsisdn(data) {
            var msisdn = data.clues.filter(function (clue) {
                return clue.name === 'msisdn'
            })
            return msisdn
        },
        // detailTarget(data) {
        //     var msisdn = this.checkMsisdn(data)
        //     if (msisdn.length > 0) {
        //         this.$router.push({ name: 'PageMultiTrackingDetailHome', params: { id: data.id ,key: encrypt(msisdn[0].value + '&&msisdn') }  })
        //     } else {
        //         this.error('Target does not have a MSISDN clue')
        //     }
        // },
        monitoringAction(status=1,data=null) {
            if(data==null){
                data=this.monitoringData
            }
            // console.log(this.monitoringTarget.length)
            var confirm = true
            let target_checked = this.monitoringTarget
            var title = 'Are you sure you want to start monitoring ?'
            if (status === 1) {
                // console.log('masuk start')
                if (target_checked.length === 0) {
                    // console.log('masuk 0')
                    confirm = false
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'Please select min 1 MSISDN!',
                    });
                } else {
                    target_checked = Object.keys(target_checked).map((key) => JSON.parse('{' + target_checked[key].replace(/(\w+):(\w+)/g, `"$1":"$2"`) + '}'));
                }
            } else {
                title = 'Are you sure you want to stop monitoring?'
            }
            // console.log('target_checked')
            // console.log(target_checked)
            if(confirm) {
                this.$swal.fire({
                    icon: 'warning',
                    title: title,
                    text: 'Multi Tracking : ' + data.group_name,
                    confirmButtonText: 'Yes!',
                    confirmButtonColor: '#DD6B55',
                    showCancelButton: true,
                    allowOutsideClick: false,
                })
                .then((result) => {
                    // console.log('on result');

                    if (result.isConfirmed) {
                        // console.log(result.value);

                        this.showLoading(true);

                        this.$store.dispatch('postMultiMonitoring', [data.id, status, [JSON.stringify(target_checked)], this.monitoringFreq])
                        .then((resp) => {
                            // console.log('postMultiMonitoring');
                            // console.log(resp);
                            if (resp.result === 'success') {
                                this.page = 0;
                                this.monitoringModal();

                                this.getData();

                                this.$swal.fire({
                                    icon: 'success',
                                    title: resp.data.message,
                                    timer: 3000,
                                });
                            } else {
                                if (resp.data.message) {
                                    this.error(resp.data.message);
                                } else {
                                    this.error();
                                }
                            }
                        });
                    }
                });
            }
        },
        monitoringModal(item=null) {
            this.monitoringTarget= []
            this.monitoringFreq= 'every30minutes'
            if (item) {            
                // var msisdn = this.checkMsisdn(item)
                // if (msisdn.length > 0) {
                this.monitoringData = item
                this.popupShowMonitoring = !this.popupShowMonitoring
                // } else {
                    // this.error('Target does not have a MSISDN clue')
                // }
            } else {            
                this.monitoringData = item
                this.popupShowMonitoring = !this.popupShowMonitoring
            }
        },

        toString(array) {
            if (array) {            
                return Object.keys(array).map(function(k){
                    return array[k].operation_name
                }).join(", ")
            }
        },
        countClues(array) {
            var ret = {}
            if (this.multi_tracking_list.data && this.multi_tracking_list.data.length > 0) {
                for (let i in array) {
                    let key = array[i].name
                    ret[key] = {
                      name: key,
                      count: ret[key] && ret[key].count ? ret[key].count + 1 : 1
                    }
                }
                return Object.values(ret)
            }
            return Object.values(ret)
        },
        getData() {
            this.$store.commit('setMultiTrackingRedirect', 'index');
            // console.log('=================== getData() route on case-management')
            // console.log(this.route_name);

            // for dispatch get data

            this.$store.dispatch('getMultiTrackingList', [this.items_per_page, (this.page + 1), this.keyword]);

            // if (this.multi_tracking_list.total_page && this.multi_tracking_list.total_page > 1) {
                // console.log(this.multi_tracking_list.total_page)
                this.pagination();
            // }
        },
        deleteData(id, name) {
            // console.log(id)
            this.$swal.fire({
                icon: 'warning',
                // title: 'Are you sure you want to delete data?',
                title: 'Are you sure you want to delete?',
                // text: id,
                // text: 'Multi Tracking : ' + name,
                text: 'Group Name : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');

                if (result.isConfirmed) {
                    // console.log(result.value);

                    this.showLoading(true);

                    this.$store.dispatch('getMultiTrackingDelete', [id])
                    .then((resp) => {
                        if (resp === 'success') {
                            this.page = 0;

                            this.getData();

                            this.$swal.fire({
                                icon: 'success',
                                title: 'Data successfully deleted!',
                                timer: 3000,
                            });
                        } else {
                            if (resp.data.message) {
                                this.error(resp.data.message);
                            } else {
                                this.error();
                            }
                        }
                    });
                }
            });
        },
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        searchKeyword() {
            // clear timeout variable
            clearTimeout(this.timeout);
            
            var self = this;
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                self.page = 0;
                self.$store.commit('setMultiTrackingList', {});

                // if (self.keyword.length > 0) {
                    self.getData();
                // }
            }, 650);
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },
        getDefaultImage(e) {
            e.target.src = this.defaultImage;
        },
        getMeetingPoint(data=null) {
            if (data) {            
                this.meetingPointData = data
                this.popupMeetingPoint = !this.popupMeetingPoint
                this.$store.dispatch('getMeetingPointList', [data.id])
            } else {            
                this.meetingPointData = data
                this.popupMeetingPoint = !this.popupMeetingPoint
            }
        },
        detailMeetingPoint(id, idMeet) {
            this.popupMeetingPoint = !this.popupMeetingPoint
            this.$router.push({ name: 'PageMultiTrackingMeetingPoint', params: { id: id ,idMeet:idMeet }  })
        },
    },
    mounted() {
        // console.log('=================== mounted on case-management index')
        if (this.route_name === 'PageMultiTrackingIndex') {
            this.$store.commit('setMultiTrackingDetail', {});
            this.getData();
            // this.pagination();
        }

    },
}
</script>

<style lang="sass">

.on-monitoring
    width: 56px

@media screen and (max-width: 480px)
    .table-multi-track
        table
            padding: 0px !important
            tbody
                tr
                    display: block
                    border-bottom: 1px solid $color-border
                    position: relative
                    padding: 16px
                    &:hover
                        td
                            background-color: transparent
                    td
                        display: block
                        padding: 0px 0px 16px 0px !important
                        border-bottom: 0px !important
                        &.mobile-action-multi
                            position: absolute
                            top: 16px
                            right: 8px
    .on-monitoring
        width: auto


%nowrap-text
    text-overflow: ellipsis
    white-space: nowrap
    display: block
    overflow: hidden
    
.name-index
    width: 150px
    @extend %nowrap-text

.no-wrap-text
    max-width: 250px
    @extend %nowrap-text

.table-static table .btn-monitoring
    div
        opacity: 1
    .btn-status
        width: 32px
        height: 32px
        display: flex
        align-items: center
        justify-content: center
        opacity: 1
        background-color: transparent
        border-radius: 100%
        border: 1px solid #e2e8f0
        &.is-stop
            border-color: #ff5722
            color: #ff5722
            background-color: transparent
            &:hover
                background-color: rgba(255, 87, 34, 0.14)
                
        &.is-play
            background-color: transparent
            border-color: #40bb5b
            color: #40bb5b
            &:hover
                background-color: rgba(64, 187, 91, 0.14)

</style>


